import { render, staticRenderFns } from "./ReturnDocListTemp.vue?vue&type=template&id=3b8c187d&"
import script from "./ReturnDocListTemp.vue?vue&type=script&lang=js&"
export * from "./ReturnDocListTemp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports